<template>
    <transition-group @before-enter="onBeforeEnter" @enter="onEnter" @leave="onLeave">
        <template v-if="currentStep === 'results'">
            <div class="col-lg-8 offset-lg-2 p-5 bg-white rounded text-center" v-if="results === 'bad'">
                <h2 class="h1">Pas op!</h2>
                <img src="/img/jic-bad.svg" class="img-fluid py-5" alt="bad"/>
                <p>Mogelijk overschrijd je één of meerdere van de normen die opgesteld zijn binnen de Praktijkrichtlijnen Fysieke Belasting. Wellicht ervaar je al lichamelijke klachten tijdens of als gevolg van je werk of zul je hier in de
                    toekomst mee te maken krijgen. Om het risico op fysieke overbelasting te voorkomen zijn er gelukkig veel tips, technieken en hulpmiddelen beschikbaar. Wil je weten hoe jij de fysieke belasting tijdens het uitvoeren van
                    jouw werk kan verminderen? Maak dan gebruik van onze gratis Til- en Transferscan. </p>
                <h2 class="mt-5">Til- en Transferscan</h2>
                <p>De Til- en Transferscan is een uitgebreide scan bij jou op locatie, waarbij een van onze ervaren specialisten meekijkt met het til- en transferproces binnen jouw organisatie. Daarbij kijken we niet alleen of de juiste
                    hulpmiddelen aanwezig zijn en correct gebruikt worden, maar ook naar factoren zoals de inrichting en toegankelijkheid van de verschillende kamers. Je ontvangt praktische tips en tricks om jouw werk nog lichter,
                    makkelijker en plezieriger te maken. Naderhand sturen we je de resultaten toe, zodat je deze ook gemakkelijk met de rest van je team kan delen.
                </p>
                <a :href="props.formPage.url" class="btn btn-primary btn-xl mx-4 my-2">Vraag de gratis Til- en Transferscan aan!</a>
                <div class="mt-4">
                    <h5>Deel deze pagina met je collega's</h5>
                    <ul class="social-footer">
                        <li><a :href="'mailto:?subject=Doe%20de%203%20stappen%20test&body=' + encodeURIComponent(currentLocation)" target="_blank"><i class="fas fa-envelope"></i></a></li>
                        <li class="ms-1"><a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(currentLocation)" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
                        <li class="ms-1"><a :href="'https://www.linkedin.com/shareArticle?url=' + encodeURIComponent(currentLocation) + '&title=Vraag%20de%20gratis%20Til-%20en%20Transferscan%20aan!'" target="_blank"><i
                            class="fab fa-linkedin-in"></i></a></li>
                        <li class="ms-1"><a :href="'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(currentLocation)" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-8 offset-lg-2 p-5 bg-white rounded text-center" v-if="results === 'good'">
                <h2 class="h1">Goed bezig!</h2>
                <img src="/img/jic-good.svg" class="img-fluid py-5" alt="good"/>
                <p>Het lijkt erop dat er binnen jouw organisatie al veel aandacht is voor het beperken van de fysieke belasting. Ben je benieuwd of er toch nog verbeteringen mogelijk zijn of is er een specifieke casus waarvoor je een
                    oplossing zoekt?<br/>Maak dan gebruik van onze gratis Til- en Transferscan. </p>
                <h2 class="mt-5">Til- en Transferscan</h2>
                <p>De Til- en Transferscan is een uitgebreide scan bij jou op locatie, waarbij een van onze ervaren specialisten meekijkt met het til- en transferproces binnen jouw organisatie. Daarbij kijken we niet alleen of de juiste
                    hulpmiddelen aanwezig zijn en correct gebruikt worden, maar ook naar factoren zoals de inrichting en toegankelijkheid van de verschillende kamers. Je ontvangt praktische tips en tricks om jouw werk nog lichter,
                    makkelijker en plezieriger te maken. Naderhand sturen we je de resultaten toe, zodat je deze ook gemakkelijk met de rest van je team kan delen.
                </p>
                <a :href="props.formPage.url" class="btn btn-primary btn-xl mx-4 my-2">Vraag de gratis Til- en Transferscan aan!</a>
                <div class="mt-4">
                    <h5>Deel deze pagina met je collega's</h5>
                    <ul class="social-footer">
                        <li><a :href="'mailto:?subject=Doe%20de%203%20stappen%20test&body=' + encodeURIComponent(currentLocation)" target="_blank"><i class="fas fa-envelope"></i></a></li>
                        <li class="ms-1"><a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(currentLocation)" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
                        <li class="ms-1"><a :href="'https://www.linkedin.com/shareArticle?url=' + encodeURIComponent(currentLocation) + '&title=Vraag%20de%20gratis%20Til-%20en%20Transferscan%20aan!'" target="_blank"><i
                            class="fab fa-linkedin-in"></i></a></li>
                        <li class="ms-1"><a :href="'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(currentLocation)" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                    </ul>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="col-lg-8 offset-lg-2">
                <form action="#" class="form p-4 p-sm-5 campaign">
                    <h2 class="text-center h1">Doe de 3 stappen test</h2>
                    <p class="text-center">Is er binnen jouw organisatie (intramurale zorginstelling) verbetering mogelijk als het gaat om de aanpak van fysieke belasting? Beantwoord de volgende 3 vragen en kom erachter.</p>
                    <!-- Progress bar -->
                    <div class="progressbar">
                        <div class="progress" id="progress" :style="'width: ' + (progressWidth)"></div>

                        <div v-for="(answer, i) in quickScan" :class="'progress-step' + (currentStep !== 'results' && parseInt(i.replace(/question/, '')) <= currentStep ? ' progress-step-active' : '')"></div>
                    </div>

                    <!-- Steps -->
                    <transition-group @before-enter="onBeforeEnter" @enter="onEnter" @leave="onLeave">
                        <div class="form-step form-step-active text-center" v-if="currentStep === 1">
                            <h3>Vraag 1</h3>
                            <p><b>Heb jij of een van je collega’s wel eens last van lichamelijke klachten tijdens of als gevolg van je werk?</b></p>
                            <div class="d-flex flex-column flex-md-row justify-content-center my-5">
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="1.1" v-model="quickScan.question1" value="Ja">
                                    <label class="form-check-label text-start ms-3 mt-2" for="1.1">
                                        Ja
                                    </label>
                                </div>
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="1.2" v-model="quickScan.question1" value="Nee">
                                    <label class="form-check-label text-start ms-3 mt-2" for="1.2">
                                        Nee
                                    </label>
                                </div>
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="1.3" v-model="quickScan.question1" value="Weet ik niet">
                                    <label class="form-check-label text-start ms-3 mt-2" for="1.3">
                                        Weet ik niet
                                    </label>
                                </div>
                            </div>
                            <div>
                                <a :class="'btn btn-next ml-auto' + (quickScan.question1 === null ? ' disabled' : '')" @click.prevent="currentStep++" :disabled="quickScan.question1 === null">Volgende</a>
                            </div>
                        </div>
                        <div class="form-step form-step-active text-center" v-if="currentStep === 2">
                            <h3>Vraag 2</h3>
                            <p><strong>Wordt er voor elke cliënt, indien nodig, gebruik gemaakt van de juiste hulpmiddelen?</strong></p>
                            <div class="d-flex flex-column flex-md-row justify-content-center my-5">
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="2.1" v-model="quickScan.question2" value="Ja">
                                    <label class="form-check-label text-start ms-3 mt-2" for="2.1">
                                        Ja
                                    </label>
                                </div>
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="2.2" v-model="quickScan.question2" value="Nee">
                                    <label class="form-check-label text-start ms-3 mt-2" for="2.2">
                                        Nee
                                    </label>
                                </div>
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="2.3" v-model="quickScan.question2" value="Weet ik niet">
                                    <label class="form-check-label text-start ms-3 mt-2" for="2.3">
                                        Weet ik niet
                                    </label>
                                </div>
                            </div>
                            <div class="btns-group">
                                <a class="btn btn-prev" @click.prevent="currentStep--">Terug</a>
                                <a :class="'btn btn-next' + (quickScan.question2 === null ? ' disabled' : '')" @click.prevent="currentStep++" :disabled="quickScan.question2 === null">Volgende</a>
                            </div>
                        </div>
                        <div class="form-step form-step-active text-center" v-if="currentStep === 3">
                            <h3>Vraag 3</h3>
                            <p><strong>Is de inrichting van de cliëntkamers afgestemd op de zorgvraag van de desbetreffende cliënt?</strong></p>
                            <div class="d-flex flex-column flex-md-row justify-content-center my-5">
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="3.1" v-model="quickScan.question3" value="Ja">
                                    <label class="form-check-label text-start ms-3 mt-2" for="3.1">
                                        Ja
                                    </label>
                                </div>
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="3.2" v-model="quickScan.question3" value="Nee">
                                    <label class="form-check-label text-start ms-3 mt-2" for="3.2">
                                        Nee
                                    </label>
                                </div>
                                <div class="form-check px-md-3 px-lg-5 camp">
                                    <input class="form-check-input" type="radio" id="3.3" v-model="quickScan.question3" value="Weet ik niet">
                                    <label class="form-check-label text-start ms-3 mt-2" for="3.3">
                                        Weet ik niet
                                    </label>
                                </div>
                            </div>
                            <div class="btns-group">
                                <a class="btn btn-prev" @click.prevent="currentStep--">Terug</a>
                                <a :class="'btn btn-next' + (quickScan.question3 === null ? ' disabled' : '')" @click.prevent="currentStep = 'results'" :disabled="quickScan.question3 === null">Resultaat</a>
                            </div>
                        </div>
                    </transition-group>
                </form>
            </div>
        </template>
    </transition-group>
</template>
<script setup>
import {ref, watch, onMounted, computed} from 'vue';
import {onBeforeEnter, onEnter, onLeave} from "../gsap-transitions";

const quickScan = ref({
    question1: null,
    question2: null,
    question3: null,
});

const props = defineProps({
    formPage: {
        type:     Object,
        required: true
    }
});

const currentStep = ref(1);

const progressWidth = computed(() => {
    return `${((currentStep.value - 1) / (Object.keys(quickScan.value).length - 1)) * 100}%`;
});

const finished = computed(() => {
    return Object.values(quickScan.value).every(value => value !== null);
})

const currentLocation = window.location.href;

const results = computed(() => {
    if(finished.value) {
        if(quickScan.value.question1 === 'Nee' && quickScan.value.question2 === 'Ja' && quickScan.value.question3 === 'Ja') {
            return 'good';
        }

        return 'bad';
    }
    return null;
});

watch(() => quickScan.value, (value) => {
    sessionStorage.setItem('quickscan-results', JSON.stringify(value));
    localStorage.setItem('quickscan-results', JSON.stringify(value));
}, {deep: true});

onMounted(() => {
    if(sessionStorage.getItem('quickscan-results')) {
        quickScan.value = JSON.parse(sessionStorage.getItem('quickscan-results'));
    }
})
</script>